export const LOGIN = '/';
export const LOGOUT = '/logout';

export const HOME = '/app';
export const PREFERENCES = '/preferences';



// WEBPACK FOOTER //
// ./src/constants/routes.js